import { getEffectiveSheetStrategy } from "./strategies";
import { getWerkplanPlateNumbers } from "./werkplanExport";

export const DEFAULT_ORDER_OVERSIZE_LENGTH = 2;
export const DEFAULT_ORDER_OVERSIZE_WIDTH = 2;

export function normalizeOrderOversizeSettings(werkplan = {}) {
  return {
    orderOversizeEnabled: Boolean(werkplan.orderOversizeEnabled),
    orderOversizeLength: Math.max(0, Number(werkplan.orderOversizeLength ?? DEFAULT_ORDER_OVERSIZE_LENGTH)),
    orderOversizeWidth: Math.max(0, Number(werkplan.orderOversizeWidth ?? DEFAULT_ORDER_OVERSIZE_WIDTH)),
  };
}

export function orderOversizeAllowed(werkplan) {
  return werkplan.globalStrategy !== "strips";
}

export function rowUsesStripStrategy(row, exportDraft, layout, sourcePanel, scope) {
  const plateNumbers = getWerkplanPlateNumbers(layout, row.id, scope);
  if (!plateNumbers) return false;

  return plateNumbers.split(", ").some((value) => {
    const sheetIndex = Number(value) - 1;
    const sheet = (layout?.sheets || []).find((entry) => entry.index === sheetIndex);
    if (!sheet) return false;

    return getEffectiveSheetStrategy(exportDraft, sheet.index) === "strips";
  });
}

export function computeOrderSize(row, exportDraft, rowOverride = {}, options = {}) {
  const { finalLength, finalWidth } = row;
  const { layout, sourcePanel, scope } = options;

  if (rowOverride.orderSizeEdited) {
    return {
      orderLength: Number(rowOverride.orderLength ?? finalLength),
      orderWidth: Number(rowOverride.orderWidth ?? finalWidth),
    };
  }

  if (layout && rowUsesStripStrategy(row, exportDraft, layout, sourcePanel, scope)) {
    return { orderLength: finalLength, orderWidth: finalWidth };
  }

  const panelOrderLength = row.panelOrderLength;
  const panelOrderWidth = row.panelOrderWidth;

  if (panelOrderLength != null || panelOrderWidth != null) {
    const orderLength = panelOrderLength != null ? Number(panelOrderLength) : finalLength;
    const orderWidth = panelOrderWidth != null ? Number(panelOrderWidth) : finalWidth;
    if (orderLength !== finalLength || orderWidth !== finalWidth) {
      return { orderLength, orderWidth };
    }
  }

  if (exportDraft.orderOversizeEnabled && orderOversizeAllowed(exportDraft)) {
    const settings = normalizeOrderOversizeSettings(exportDraft);
    return {
      orderLength: finalLength + settings.orderOversizeLength,
      orderWidth: finalWidth + settings.orderOversizeWidth,
    };
  }

  return { orderLength: finalLength, orderWidth: finalWidth };
}

export function hasOrderOversize(orderLength, orderWidth, finalLength, finalWidth) {
  return Number(orderLength) !== Number(finalLength)
    || Number(orderWidth) !== Number(finalWidth);
}

export function resolveExportRow(row, exportDraft, rowOverride = {}, options = {}) {
  const sizes = computeOrderSize(row, exportDraft, rowOverride, options);

  return {
    ...row,
    ...sizes,
    hasOrderOversize: hasOrderOversize(
      sizes.orderLength,
      sizes.orderWidth,
      row.finalLength,
      row.finalWidth,
    ),
  };
}
